import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import {
  LoginAppProvider,
  LOGIN_FORM_WINDOW_EVENTS,
  useCustomerSession,
  useCustomerSession_asController,
} from "../../../Common";

export interface ReactMyBagLoginAppConsumer {
  hasTheUserLoggedInWhileUsingThisPage_andWereInitiallyNotLoggedInToStartWith: boolean;
  userLoggedInWithThisEmailLastIHeard: string | null;
}
const defaultValue = {} as unknown as ReactMyBagLoginAppConsumer;
const ReactMyBagLoginAppContext = React.createContext(defaultValue);
const ReactMyBagLoginAppContext_44 = React44ms.React.createContext(
  defaultValue,
  ReactMyBagLoginAppContext
);

export const ReactMyBagLoginAppProvider: React.FunctionComponent = (props) => {
  const { isCustomerLoggedIn: wasTheCustomerLoggedInInitially } =
    useCustomerSession();
  const { handleCustomerLoggedIn } = useCustomerSession_asController();

  const [
    hasTheUserLoggedInWhileUsingThisPage_andWereInitiallyNotLoggedInToStartWith,
    setHasTheUserLoggedInWhileUsingThisPage_andWereInitiallyNotLoggedInToStartWith,
  ] = React.useState(() => wasTheCustomerLoggedInInitially);
  const [
    userLoggedInWithThisEmailLastIHeard,
    setUserLoggedInWithThisEmailLastIHeard,
  ] = React.useState<string | null>(null);
  const handleLoginSuccess = React.useCallback((event) => {
    setUserLoggedInWithThisEmailLastIHeard(event.detail?.email);
    setHasTheUserLoggedInWhileUsingThisPage_andWereInitiallyNotLoggedInToStartWith(
      true
    );
    handleCustomerLoggedIn();
  }, []);
  React.useEffect(() => {
    window.addEventListener(
      LOGIN_FORM_WINDOW_EVENTS.LOGIN_SUCCESS,
      handleLoginSuccess
    );
    return () => {
      window.removeEventListener(
        LOGIN_FORM_WINDOW_EVENTS.LOGIN_SUCCESS,
        handleLoginSuccess
      );
    };
  }, [handleLoginSuccess]);

  const value: ReactMyBagLoginAppConsumer = React.useMemo(
    () => ({
      hasTheUserLoggedInWhileUsingThisPage_andWereInitiallyNotLoggedInToStartWith,
      userLoggedInWithThisEmailLastIHeard,
    }),
    [
      hasTheUserLoggedInWhileUsingThisPage_andWereInitiallyNotLoggedInToStartWith,
      userLoggedInWithThisEmailLastIHeard,
    ]
  );
  return (
    <LoginAppProvider
      shouldLoginUsingTheSpecialAsynchronousApiInsteadOfFormPost
    >
      <ReactMyBagLoginAppContext.Provider value={value}>
        <ReactMyBagLoginAppContext_44.Provider value={value}>
          {props.children || []}
        </ReactMyBagLoginAppContext_44.Provider>
      </ReactMyBagLoginAppContext.Provider>
    </LoginAppProvider>
  );
};

export const useReactMyBagLoginApp = () => {
  const context = React.useContext(ReactMyBagLoginAppContext);

  if (context === defaultValue) {
    throw new Error(
      "useReactMyBagLoginApp must be used within a ReactMyBagLoginAppProvider"
    );
  }

  return context;
};

export const useReactMyBagLoginApp_44 = () => {
  const context = React44ms.React.useContext(ReactMyBagLoginAppContext_44);

  if (context === defaultValue) {
    throw new Error(
      "useReactMyBagLoginApp_44 must be used within a ReactMyBagLoginAppProvider"
    );
  }

  return context;
};
